<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('resources') }}</h2>
				<ja-button
					v-if="showCreateInterest"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table Resources -->
			<ja-resources-table
				v-if="showCreateInterest && resourcesData"
				:data="resourcesData"
				@deleteRow="handleDeleteRow"
				@editRow="handleEditRow"
			></ja-resources-table>
			<!-- Create new Resources -->
			<ja-create-new-resources
				v-if="!showCreateInterest"
				:show="!showCreateInterest"
				:create-data="dataEdit"
				@saveResource="handleSaveResource"
				@cancel="handleCancel"
			></ja-create-new-resources>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import ResourcesTable from './ResourcesTable.vue';
import CreateNewResources from './CreateNewResources.vue';
import ResourceServices from '@/services/cms/ResourceServices';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaResourcesTable: ResourcesTable,
		jaCreateNewResources: CreateNewResources,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreateInterest: true,
			resourcesData: null,
			dataEdit: null
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.getResources();
		},
		questionTypeIndex(newIndex) {
			this.updateQuestionFormat(newIndex);
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreateInterest = true;
			} else {
				this.showCreateInterest = false;
			}
		}
	},
	mounted() {
		if (this.selectedFacilityId != null) {
			this.$store.commit('setLoading', true);
			this.getResources();
		}
	},
	methods: {
		async getResources() {
			const data = await ResourceServices.getAll(this.selectedFacilityId);
			this.resourcesData = data;
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await ResourceServices.getByID();
			this.dataEdit = data;
			this.showCreateInterest = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await ResourceServices.deleteById(rowData.resourceID);
			await this.getResources();
		},
		async handleEditRow(rowData) {
			const data = await ResourceServices.getByID(rowData.resourceID);
			this.dataEdit = data;
			this.showCreateInterest = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleSaveResource(resource) {
			this.$store.commit('setLoading', true);
			resource.facility_ID = this.selectedFacilityId;
			await ResourceServices.update(resource);
			await this.getResources();
			this.showCreateInterest = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getResources();
			this.showCreateInterest = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
}
</style>
